const decelerationRates = {
  fast: 0.99,
  normal: 0.998,
};

export const projection = (initialVelocity, rateName = 'normal') => {
  const decelerationRate = decelerationRates[rateName] || rateName;
  return (initialVelocity * decelerationRate) / (1 - decelerationRate);
};

export const findNearestNumberInArray = (n, arr) => {
  const sortedArr = [...arr].sort((a, b) => a - b);
  if (n <= sortedArr[0]) return sortedArr[0];
  if (n >= sortedArr[arr.length - 1]) return sortedArr[arr.length - 1];

  for (let i = 1; i < sortedArr.length; i++) {
    const prev = sortedArr[i - 1];
    const current = sortedArr[i];
    if (current === n) return current;
    if (current > n && prev < n) {
      return current - n < n - prev ? current : prev;
    }
  }

  return false;
};

const rubberBand = (distance, dimension, constant = 0.15) => {
  return (distance * dimension * constant) / (dimension + constant * distance);
};

export const rubberBandIfOutOfBounds = (min, max, delta, constant) => {
  if (delta < min) return -rubberBand(min - delta, max - min, constant) + min;
  if (delta > max) return rubberBand(delta - max, max - min, constant) + max;

  return delta;
};
